import React from "react";
import {Export} from "../../../../../common/export/export";
import {Col, Form} from "antd";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {UIInputWidgetPrice} from "../../../../../common/ui/input/widget/price/ui.input.widget.price";
import {UiInputWidgetDateRange} from "../../../../../common/ui/input/widget/date-range/ui.input.widget.date-range";

interface ExtendedReportModalProps {
    onClose: () => void;
}

export const ExtendedReportModal: React.FC<ExtendedReportModalProps> = ({onClose}) => {

    const t = useTranslate();

    return (
        <Export
            title={"ARTICLES.PRICES.DOWNLOAD.TITLE"}
            withBasicExportFields
            width={700}
            isShown={true}
            config={{
                link: "/api/v3/reports/custom/extended-price",
            }}
            onClose={() => onClose()}
        >
            <Col span={24}>
                <Form.Item
                    label={t("ARTICLES.PRICES.TITLE")}
                    name={"price"}
                    rules={[
                        {
                            required: true,
                            message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                        },
                    ]}
                >
                    <UIInputWidgetPrice />
                </Form.Item>
            </Col>
            <Col span={24}>
                <Form.Item
                    label={t("DATE")}
                    name={"date"}
                    rules={[
                        {
                            required: true,
                            message: t("FROM.ERROR.PLEASE_SELECT_VALUE"),
                        },
                    ]}
                >
                    <UiInputWidgetDateRange />
                </Form.Item>
            </Col>
        </Export>
    )
}